import React, {useEffect, useState} from 'react'
import ModalCodigoEnviado from '../../components/Modals/ModalsCreacion/ModalCodigoEnviado'
import {Link, useHistory} from 'react-router-dom'
import DesignExterno from '../../components/DesignExterno/DesignExterno'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {bindActionCreators} from 'redux'
import {actionsOlvidoPass, actionsValidacionesOlvidoPass} from '../../actions/action-creators'
import {OLVIDO_PASS_TYPES} from '../../constants/olvidoPass.types'
import {isNullOrEmpty} from '../../utils/strings.utils'
import {olvidoPassClear} from '../../actions/OlvidoPass/olvidoPass.actions'
import DarkCheck from '../../media/felsv/dark_check_icon.svg'
import SecondaryCheck from '../../media/felsv/secondary_check_icon.svg'
import InputIcon from '../../components/Inputs/InputIcon'
import './styles/verify-user.css'

const CodigoVerificacion = () => {
  const [disable, setDisable] = useState(true)
  const history = useHistory()
  const [openModal, setOpenModal] = useState(false)
  const verifyCode = useSelector((state: State) => state.olvidoPass.formVerificar)
  const dispatch = useDispatch()

  const actions = bindActionCreators(actionsOlvidoPass, dispatch)
  const validaciones = bindActionCreators(actionsValidacionesOlvidoPass, dispatch)

  useEffect(() => {
    dispatch(olvidoPassClear())
    if (isNullOrEmpty(localStorage.getItem(OLVIDO_PASS_TYPES.KEY_EMAIL))) return history.push('/')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (verifyCode.code && !verifyCode.error) setDisable(false)
    else setDisable(true)
  }, [verifyCode])

  const submit = async (e: any) => {
    e.preventDefault()
    if (await validaciones.opValidacionesFormVerificacionEnviar()) return
    if (await actions.olvidoPassVerificacionCodigoEnviar())
      history.push(`/restore/${verifyCode.code}`)
  }

  const reenviarCodigo = async () => {
    const email = localStorage.getItem(OLVIDO_PASS_TYPES.KEY_EMAIL) || ''
    if (await actions.olvdioPassFormRestablecerSend(email)) setOpenModal(true)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    actions.olvidoPassFormVerifyCodeHandleChangeInput(e)
    validaciones.opValidacionesOnBlurFormVerificacion(e)
  }

  return (
    <DesignExterno
      title={
        <span>
          Bienvenido a <span style={{color: '#019FC5'}}>FELes APP</span>
        </span>
      }
    >
      {openModal && <ModalCodigoEnviado onClose={() => setOpenModal(false)} />}
      <div className='centrar-horizontal'>
        <section className='wf-section'>
          <div className='w-form'>
            <Link to='/forgot'>
              <span className='back-button w-inline-block' />
            </Link>
            <form
              className='form-content'
              data-wf-page-id='64af244a307770eac998c0c4'
              data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
              onSubmit={submit}
            >
              <div>
                <h2 className='h2-titles'>Verificación</h2>
                <div>Se ha enviado un código de verificación a tu correo electrónico.</div>
              </div>
              <div className='form-separator'></div>
              <div>
                <label htmlFor='idCode' className='field-label m'>
                  Código de verificación
                </label>
                <InputIcon
                  secondaryIcon={SecondaryCheck}
                  darkIcon={DarkCheck}
                  type='text'
                  className='m text-field w-input'
                  maxLength={20}
                  autoFocus
                  name='code'
                  data-name='code'
                  placeholder='Código de verificación'
                  id='idCode'
                  value={verifyCode.code}
                  onChange={handleChange}
                  onBlur={validaciones.opValidacionesOnBlurFormVerificacion}
                />
                {verifyCode.error && <p className='alert s'>{verifyCode.error}</p>}
              </div>
              <div className='div-reenviar-codigos' style={{margin: '7% 0 2%'}}>
                <div>¿No te ha llegado tu código?</div>
                <button
                  type='button'
                  className='m button-reenviar-codig-text2'
                  onClick={reenviarCodigo}
                >
                  Reenviar código
                </button>
              </div>
              <div className='m buttons-div' style={{marginBottom: '5%'}}>
                <button type='submit' className='m button w-inline-block' disabled={disable}>
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
    </DesignExterno>
  )
}

export default CodigoVerificacion
